import * as $ from 'jquery';

//declare var process: any;

export class Dispatcher {
    private _callbacks: any[] = [];
    private _promises: any[] = [];

    private executeCallback(obj, payload) {
        // if (process.env.DEBUG === 'true') {
        //     return obj.callback.call(obj.context, payload);
        // }

        try {
            return obj.callback.call(obj.context, payload);
        } catch (e) {
            console.log('An error happened:', e);

            return true;
        }
    }

    /**
     * Add a promise to the queue of callback invocation promises.
     */
    private addPromise(obj, payload) {
        var def = $.Deferred<any>();

        this._promises.push(def);

        var result = this.executeCallback(obj, payload);

        if (result) {
            def.resolve(payload);
        } else {
            def.reject(new Error('Dispatcher callback unsuccessful'));
        }
    }

    /**
     * Empty the queue of callback invocation promises.
     */
    private clearPromises() {
        this._promises = [];
    }

    /**
     * Register a Store's callback so that it may be invoked by an action.
     */
    public register(callback, context) {
        this._callbacks.push({
            callback: callback,
            context: context
        });

        return this._callbacks.length - 1; // index
    }

    public unregister(i) {
        this._callbacks[i] = null;
    }

    /**
     * dispatch
     */
    public dispatch(payload) {
        this._callbacks.forEach((obj) => {
            if (obj == null) {
                return;
            }

            this.addPromise(obj, payload);
        });

        $.when.apply($, this._promises).always(() => {
            this.clearPromises();
        });
    }
}
